// Formata as UCS para o padrão
const formatUcs = (ucs: Record<string, string>) => {
  const formattedUcs: string[] = []

  // Percorrer índices de 1 a 9 (ou outro limite definido para as UCs)
  for (let i = 1; i <= 9; i++) {
    const uc = ucs[`Cliente_UC${i}`]
    const cm = ucs[`Cliente_CM${i}`]
    const grupo = ucs[`Cliente_Grupo${i}`]
    const subgrupo = ucs[`Cliente_Subgrupo${i}`]
    const mt = ucs[`Cliente_MT${i}`]

    // Verificar se os campos obrigatórios existem para evitar entradas incompletas
    if (uc && cm && grupo && subgrupo && mt) {
      formattedUcs.push(`UC${i} ${uc} | CM${i} ${cm} | GS${i} ${grupo}-${subgrupo} | MT${i} ${mt}`)
    }
  }

  // Unir as UCs formatadas separadas por ***
  return formattedUcs.join(' *** ')
}

const getPartnerName = (str: string) => {
  const match = str.match(/_(.+)$/) // Encontra o que está após o primeiro underline
  return match ? match[1] : '' // Retorna o valor ou null se não houver underline
}

const getPartnerCode = (str: string) => {
  const match = str.match(/^([^_]+)_/) // Encontra tudo antes do primeiro underline
  return match ? match[1] : str // Retorna a parte antes do underline ou a string inteira
}

const formatDateToUS = (dateString: string) => {
  const [day, month, year] = dateString.split('/') // Divide a string em partes
  return `${year}-${month}-${day}` // Reorganiza no formato ISO
}

export { formatUcs, getPartnerName, getPartnerCode, formatDateToUS }
